"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelUserSchema = exports.PanelUserAccessScope = void 0;
const mongoose_1 = require("mongoose");
var PanelUserAccessScope;
(function (PanelUserAccessScope) {
    PanelUserAccessScope[PanelUserAccessScope["ADMIN"] = 0] = "ADMIN";
    PanelUserAccessScope[PanelUserAccessScope["POLICY_GENERATOR"] = 1] = "POLICY_GENERATOR";
    PanelUserAccessScope[PanelUserAccessScope["FLASH_APPS_RO"] = 2] = "FLASH_APPS_RO";
    PanelUserAccessScope[PanelUserAccessScope["FLASH_APPS_RW"] = 3] = "FLASH_APPS_RW";
    PanelUserAccessScope[PanelUserAccessScope["OFFERS_RO"] = 4] = "OFFERS_RO";
    PanelUserAccessScope[PanelUserAccessScope["OFFERS_RW"] = 5] = "OFFERS_RW";
    PanelUserAccessScope[PanelUserAccessScope["OFFERWALL_RO"] = 6] = "OFFERWALL_RO";
    PanelUserAccessScope[PanelUserAccessScope["OFFERWALL_RW"] = 7] = "OFFERWALL_RW";
    PanelUserAccessScope[PanelUserAccessScope["ASO_LOGS"] = 8] = "ASO_LOGS";
    PanelUserAccessScope[PanelUserAccessScope["MANAGER"] = 9] = "MANAGER";
    PanelUserAccessScope[PanelUserAccessScope["DEPLOYER"] = 10] = "DEPLOYER";
    PanelUserAccessScope[PanelUserAccessScope["TESTER"] = 11] = "TESTER";
    PanelUserAccessScope[PanelUserAccessScope["CAPS_RW"] = 12] = "CAPS_RW";
})(PanelUserAccessScope = exports.PanelUserAccessScope || (exports.PanelUserAccessScope = {}));
exports.PanelUserSchema = new mongoose_1.Schema({
    username: {
        type: String,
        unique: true
    },
    passwordHash: String,
    accessScopes: [{
            type: String,
            enum: PanelUserAccessScope,
            default: [],
        }]
});
